import { preauthAccountAction } from "@/actions/account";
import type { User } from "firebase/auth";
import { MAX_PREAUTH_RETRIES } from "../const";

export type PreauthSessionResult =
  | {
      ok: true;
      token: string;
      expirationTime: string;
      reauthenticated: boolean;
    }
  | { ok: false; error: unknown };

export default async function preauthSession(
  user: User,
  serviceLocale: string | undefined,
): Promise<PreauthSessionResult> {
  let tokenResult = await user.getIdTokenResult();
  let reauthenticated = false;
  let retries = 0;

  try {
    while (retries <= MAX_PREAUTH_RETRIES) {
      const response = await preauthAccountAction({
        locale: serviceLocale,
        token: tokenResult.token,
      });

      if (!response.reauthNecessary) {
        return {
          ok: true,
          token: tokenResult.token,
          expirationTime: tokenResult.expirationTime,
          reauthenticated,
        };
      }

      retries += 1;
      if (retries > MAX_PREAUTH_RETRIES) {
        return {
          ok: false,
          error: new Error("Token refresh validation failed"),
        };
      }

      reauthenticated = true;
      tokenResult = await user.getIdTokenResult(true);
    }

    return { ok: false, error: new Error("Preauth retry limit exceeded") };
  } catch (error) {
    return { ok: false, error };
  }
}
